import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-msin-alert',
  templateUrl: './msin-alert.component.html',
  styleUrls: ['./msin-alert.component.scss']
  
})
export class MsinAlertComponent implements OnInit {
  
  dialogTitle: string = "";
  bShowCancelButton: boolean = false;
  bShowConfirmButton: boolean = false;
  confirmButtonColor: string = "";
  confirmButtonText: string = "";
  cancelButtonText: string = "";
  cancelButtonColor: string = "";
  closeOnConfirm: boolean = false;
  closeOnCancel: boolean = false;
  dialogResult: string = "confirmed";

  constructor( @Inject(MAT_DIALOG_DATA) public dialogData: any, public dialogRef: MatDialogRef<MsinAlertComponent>,  ) { }

  ngOnInit(): void {
    this.dialogTitle = this.dialogData['title'];
    this.bShowCancelButton = Boolean(this.dialogData['showCancelButton']);
    this.bShowConfirmButton = Boolean(this.dialogData['showConfirmButton']);
    this.confirmButtonColor = this.dialogData['confirmButtonColor'];
    this.cancelButtonColor = this.dialogData['cancelButtonColor'];
    this.confirmButtonText = this.dialogData['confirmButtonText'];
    this.cancelButtonText = this.dialogData['cancelButtonText'];
    this.closeOnConfirm = Boolean(this.dialogData['closeOnConfirm']);
    this.closeOnCancel = Boolean(this.dialogData['closeOnCancel']);
  }

  fnConfirm(){}

  fnCancel(){
    this.dialogRef.close();
  }
}
